import { useState, useEffect, useCallback, useRef } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const ATTEMPTS = 3;
const BACKOFF_MS = 900;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default function useBlogArticles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const cancelled = useRef(false);

  const loadArticles = useCallback(async () => {
    setLoading(true);
    setError(null);

    for (let attempt = 1; attempt <= ATTEMPTS; attempt += 1) {
      try {
        const r = await fetch(`${API}/api/blog/articles?limit=50&offset=0`);
        if (!r.ok) throw new Error("Failed to load");
        const data = await r.json();
        if (cancelled.current) return;
        setArticles(data.articles);
        setLoading(false);
        return;
      } catch (err) {
        if (cancelled.current) return;
        if (attempt === ATTEMPTS) {
          setError(err.message);
          setLoading(false);
          return;
        }
        await wait(BACKOFF_MS * attempt);
      }
    }
  }, []);

  useEffect(() => {
    cancelled.current = false;
    loadArticles();
    return () => {
      cancelled.current = true;
    };
  }, [loadArticles]);

  return { articles, loading, error, retry: loadArticles };
}
